module.exports = __webpack_public_path__ + "static/making-sustainability-5bb35cf5a2f623c653118f787e67c2cf.jpg";